import dayjs from 'dayjs';

import { Text } from '../../../../shared/uiComponents';
import { Calendar, Client, Time } from '../../../../shared/Assets/sessionDetailsSVGs';
import { Settings } from '../../../../shared/Assets/menuIcons';
import { PEARL, TEXT } from '../../../../shared/Helpers/colors';

import { GetSessionProperties } from '../../../../redux/API/ClientAPIHelpers/calendarProperties';

const SessionDetails = ({ data }: { data: GetSessionProperties }) => (
	<div className="sessionInfo">
		<div className="card cardContentWidth">
			<div className="icon">
				<Client />
			</div>
			<div className="text">
				<Text title="Client" type="pxs" fontWeight="medium" color={TEXT.TERTIARY} />
				<Text title={data.client.fullName} type="psm" fontWeight="semiBold" />
			</div>
		</div>
		<div className="card cardContentWidth">
			<div className="icon">
				<Settings color={PEARL.BASE[500]} />
			</div>
			<div className="text">
				<Text title="Session type" type="pxs" fontWeight="medium" color={TEXT.TERTIARY} />
				<Text title={data.sessionType.name} type="psm" fontWeight="semiBold" />
			</div>
		</div>
		<div className="card">
			<div className="icon">
				<Calendar color={PEARL.BASE[500]} />
			</div>
			<div className="text">
				<Text title="Date" type="pxs" fontWeight="medium" color={TEXT.TERTIARY} />
				<Text title={dayjs(data.date).format('MM/DD/YYYY')} type="psm" fontWeight="semiBold" />
			</div>
		</div>
		<div className="card">
			<div className="icon">
				<Time />
			</div>
			<div className="text">
				<Text title="Start time" type="pxs" fontWeight="medium" color={TEXT.TERTIARY} />
				<Text title={dayjs(data.startTime).format('hh:mm A')} type="psm" fontWeight="semiBold" />
			</div>
		</div>
	</div>
);

export default SessionDetails;
